import shiColors from "../../theme/shiColors";

export const colorSeverities = {
  BadCritical: shiColors.red.DEFAULT,
  WarningHigh: shiColors.orange.DEFAULT,
  Medium: shiColors.yellow.DEFAULT,
  GoodLow: shiColors.green.DEFAULT,
};
